import { Link2, UserCheck } from 'lucide-react'

import type { Contact } from '@/gen/cortado/v1/contacts_pb'
import { formatFullName } from '@/lib/utils'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'

interface PortalLinkMenuItemsProps {
  /** The lead's contact. A tracked link needs one with an id; without it only the generic link is offered. */
  contact?: Pick<Contact, 'id' | 'firstName' | 'lastName'>
  onCopyRecipientLink: () => void
  onCopyGenericLink: () => void
  disabled?: boolean
}

/**
 * The two portal link kinds as menu items: a tracked link minted for the
 * lead's contact, whose visits are attributed to them, and a generic link
 * anyone can open, whose visits stay anonymous.
 */
export function PortalLinkMenuItems({ contact, onCopyRecipientLink, onCopyGenericLink, disabled }: PortalLinkMenuItemsProps) {
  const recipientName = formatFullName(contact?.firstName, contact?.lastName, 'contact')

  return (
    <>
      {contact?.id && (
        <DropdownMenuItem onSelect={onCopyRecipientLink} disabled={disabled}>
          <UserCheck />
          <span className="flex flex-col">
            <span>Copy link for {recipientName}</span>
            <span className="text-xs text-muted-foreground">Visits are tracked to them</span>
          </span>
        </DropdownMenuItem>
      )}
      <DropdownMenuItem onSelect={onCopyGenericLink} disabled={disabled}>
        <Link2 />
        <span className="flex flex-col">
          <span>Copy generic link</span>
          <span className="text-xs text-muted-foreground">Anyone can open it; visits stay anonymous</span>
        </span>
      </DropdownMenuItem>
    </>
  )
}
